import "firebase/firestore"
import {
  useFirestore,
  useFirestoreCollectionData,
  useFirestoreDocDataOnce,
} from "reactfire"

const EMPTY_LIST = []

const useAllOrders = () => {
  const collection = useFirestore().collection("orders")
  const query = collection.orderBy("timestamp", "asc")
  const { status, data } = useFirestoreCollectionData(query, { idField: "id" })
  const timestamp = useFirestore.FieldValue.serverTimestamp()

  const addOrder = (values) => collection.add({ ...values, timestamp })
  const updateOrder = (id, values) =>
    collection.doc(id).set(values, { merge: true })
  const removeOrder = (id) => collection.doc(id).delete()

  const locationQuery = useFirestore()
    .collection("locations")
    .orderBy("name", "asc")
  const { data: locations } = useFirestoreCollectionData(locationQuery, {
    idField: "id",
  })

  return {
    orders: data || EMPTY_LIST,
    isLoading: status === "loading",
    addOrder,
    updateOrder,
    removeOrder,
    locations: locations || EMPTY_LIST,
  }
}

const useOrders = () => {
  const collection = useFirestore().collection("orders")
  const timestamp = useFirestore.FieldValue.serverTimestamp()
  const addOrder = (values) => collection.add({ ...values, timestamp })

  const locationQuery = useFirestore()
    .collection("locations")
    .orderBy("name", "asc")
  const { data: locations } = useFirestoreCollectionData(locationQuery, {
    idField: "id",
  })

  return {
    addOrder,
    locations: locations || EMPTY_LIST,
  }
}

const useOrder = (orderId) => {
  const ref = useFirestore().doc(`orders/${orderId}`)
  const { status, data: order } = useFirestoreDocDataOnce(ref)

  const locationQuery = useFirestore()
    .collection("locations")
    .orderBy("name", "asc")
  const { data: locations } = useFirestoreCollectionData(locationQuery, {
    idField: "id",
  })

  return {
    order,
    isLoading: status === "loading",
    locations: locations || EMPTY_LIST,
  }
}

export { useAllOrders, useOrders, useOrder }
